import { applyMiddleware, legacy_createStore as createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import rootReducer from "./rootReducer";
import rootSaga from "./sagas/rootSaga";

// Persist config
const persistConfig = {
    key: "root",
    storage,
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Middleware
const sagaMiddleware = createSagaMiddleware();
const store = createStore(persistedReducer, applyMiddleware(sagaMiddleware));

// Run sagas
sagaMiddleware.run(rootSaga);

// Persistor
const persistor = persistStore(store);

export { store, persistor };
